import { NgModule } from '@angular/core';
import { CustomFieldEditorComponent } from './custom-field-editor.component';
import { SharedModule } from '../../../../../../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
    ],
    declarations: [CustomFieldEditorComponent],
    exports: [CustomFieldEditorComponent],
})
export class CustomFieldEditorModule
{
}
